/** @format */

import React, {useContext} from 'react';
import PushableRequestButton from 'frontier/utilities/pushable_request_button';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

export default function SingleOrderSplitShipmentButton({orderId, shipmentId}) {
    const ctx = useContext(CartCheckoutContext);
    return (
        <PushableRequestButton
            requestData={{orderId}}
            onDone={({body: {shipments}}) => {
                ctx.onUpdateWithoutSave({shipments: {$set: shipments}});
            }}
            endpoint={`/account/shipments/split/${shipmentId}`}
            className="ship-elsewhere-button color-action-primary font-body-sm">
            <>Ship elsewhere</>
            <>Saving...</>
        </PushableRequestButton>
    );
}
